import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RootStore } from '../store/root-store';
import { GlobalStore } from '../store/global-store';
import { environment } from 'src/environment';
import { TostDisplayComponent } from "../shared/components/tost-display/tost-display.component";
import { TostesStore } from '../store/tostes-store';
import { Tost } from '../shared/models/tostes.model';

@Component({
    selector: 'que-app-warp',
    templateUrl: './app-warp.component.html',
    styleUrls: ['./app-warp.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterOutlet, TranslateDirective, TranslatePipe, TostDisplayComponent]
})
export class AppWarpComponent implements OnInit {
  count$ = toSignal(inject(RootStore).count$);
  tostesSig$ = inject(TostesStore).tostesSig$;
  tostesSigHigh$ = inject(TostesStore).tostesSigHigh$;
  userDetails$ = toSignal(inject(GlobalStore).loggedUserDetails$);
  isAfter$ = signal(false);
  #tostesStore = inject(TostesStore);
  title = environment.title;
  
  client = environment.client;
  ngOnInit() {
    // Set the isAfter to true after 5 seconds to apply the .afterLoad class
    setTimeout(() => {
      this.isAfter$.set(true)
    }, 3000);
  }

  removeTost(tost:Tost){
    this.#tostesStore.removeTost(tost);
  }
  createComponent(index: any, item: any) {
    return item;
  }
}
